import axios from 'axios'
import { extractError } from '../utils/errorHandler'

/** E-mail de riscos do planejamento da própria pessoa (tela do Planejamento). */
export const get = async () => {
  try {
    const { data } = await axios.get('planningRiskSubscription')
    return data
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}

/** { enabled, allWorkStations, workStationIds } */
export const save = async (subscription) => {
  try {
    const { data } = await axios.put('planningRiskSubscription', subscription)
    return data
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}
